import { Text, TextStyle, Sprite, Texture, Container } from "pixi.js";
import { PriceHistoryResourcePackage } from "../resources/PriceHistoryResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";
import { GameFont } from "../../../common/GameFont";

export class PriceHistoryHeader extends Container {
    private static readonly DATE_TEXT = "DATE";
    private static readonly PRICE_TEXT = "PRICE[$]";
    private static readonly SELLER_TEXT = "SELLER";
    private static readonly BUYER_TEXT = "BUYER";

    private bg: Sprite;
    private textBox: HBox;
    private dateText: Text;
    private priceText: Text;
    private sellerText: Text;
    private buyerText: Text;

    public constructor(
        private readonly priceHistoryResources: PriceHistoryResourcePackage
    ) {
        super();
        this.bg = new Sprite(this.priceHistoryResources.assets_views_price_history_header_png);
        this.textBox = new HBox(100);
        this.dateText = new Text(PriceHistoryHeader.DATE_TEXT, new HeaderTextStyle());
        this.priceText = new Text(PriceHistoryHeader.PRICE_TEXT, new HeaderTextStyle());
        this.sellerText = new Text(PriceHistoryHeader.SELLER_TEXT, new HeaderTextStyle());
        this.buyerText = new Text(PriceHistoryHeader.BUYER_TEXT, new HeaderTextStyle());
        this.textBox.addChild(this.dateText, this.priceText, this.sellerText, this.buyerText);
        this.textBox.position.set(this.bg.width * 0.5 - this.textBox.width * 0.5, this.bg.height * 0.5 - this.textBox.height * 0.5 + 4);
        this.addChild(this.bg, this.textBox);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super(
            new TextStyle({
                align: "center",
                fill: "#ffffff",
                fontFamily: GameFont.DEFAULT_FONT,
                fontSize: 40,
            })
        );
    }
}
